<div
  class="menu-form-page"
  [class.menu-mobile-step-basic]="mobileStep === 'basic'"
  [class.menu-mobile-step-items]="mobileStep === 'items'">
  <div class="page-header">
    <div class="header-left">
      <mat-icon class="back-icon" (click)="onMobileBack()">keyboard_arrow_left</mat-icon>
      <span class="page-title desktop-only">{{ (menuToEdit ? 'menu_management.edit' : 'menu_management.add') | translate }}</span>
      <span class="page-title mobile-only">{{ mobilePageTitleKey | translate }}</span>
    </div>
  </div>

  <div class="two-column-layout">
    <div class="left-column menu-basic-panel">
      <div class="menu-form-container" [class.add-page]="isAddPage">
        <form [formGroup]="menuForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <app-filled-form-field
              [label]="'menu_management.restaurant_name' | translate"
              [formControl]="businessNameControl"
              [optional]="true"
              [isControlInvalid]="(businessNameControl.invalid && businessNameControl.touched) || errorMessages['business_name'] != null"
              [errorMessage]="errorMessages['business_name'] || getErrorMessage('business_name')">
            </app-filled-form-field>
          </div>

          <div class="form-group">
            <app-filled-form-field
            [label]="'menu_management.menu_name_required' | translate"
              [formControl]="menuNameControl"
              [isControlInvalid]="(menuNameControl.invalid && menuNameControl.touched) || errorMessages['menu_name'] != null"
              [errorMessage]="errorMessages['menu_name'] || getErrorMessage('menu_name')">
            </app-filled-form-field>
          </div>

          <div class="form-group">
            <app-filled-form-field
              [label]="'menu_management.address' | translate"
              [formControl]="addressControl"
              [type]="'input'"
              [optional]="true"
              [isControlInvalid]="(addressControl.invalid && addressControl.touched) || errorMessages['address'] != null"
              [errorMessage]="errorMessages['address'] || getErrorMessage('address')">
            </app-filled-form-field>
          </div>

          <div class="form-group">
            <label class="form-label desktop-only">{{ 'menu_management.card_username' | translate }} <span class="required-asterisk">*</span></label>
            <app-scan-multi-select
              [items]="mappedUsernames"
              [maxSelectedItemsCount]="100"
              bindLabel="name"
              bindValue="name"
              formControlName="linked_users"
              [notFoundText]="'menu_management.no_usernames_found' | translate"
              [label]="'menu_management.select_cards_for_menu' | translate"
              [showSeeMoreButton]="!noMoreResults && mappedUsernames.length >= searchPageSize"
              [closeOnSelect]="true"
              (search)="onSearchUsernames($event)"
              (loadMore)="loadMoreUsernames()">
            </app-scan-multi-select>
            @if (errorMessages['linked_users'] || getErrorMessage('linked_users')) {
              <div class="error-message">
                {{ errorMessages['linked_users'] || getErrorMessage('linked_users') }}
              </div>
            }
          </div>

          <div class="form-divider desktop-only"></div>

          <div class="form-actions-section desktop-only">
            <button type="button" class="action-button add-search-btn" (click)="onAddSearch()" [disabled]="hasSearchField">
              <mat-icon>search</mat-icon>
              <span>{{ 'menu_management.add_search' | translate }}</span>
            </button>
            <button type="button" class="action-button add-quantity-btn" (click)="onAddMenuItemWithQuantity()">
              <div class="quantity-icon-wrapper">
              <img src="../../../../assets/menu/menu_qty_icon.svg" style="width: 13px;" alt="">
              </div>
              <span>{{ 'menu_management.add_menu_item_with_quantity' | translate }}</span>
            </button>
            <button type="button" class="action-button add-standard-btn" (click)="onAddStandardMenuItem()">
              <mat-icon>add</mat-icon>
              <span>{{ 'menu_management.add_standard_menu_item' | translate }}</span>
            </button>
          </div>

          <div class="checkbox-section desktop-only">
            <label class="checkbox-label">
              <input type="checkbox" formControlName="allowsMultipleProducts" class="checkbox-input">
              <span>{{ 'menu_management.allow_multiple_selection' | translate }}</span>
            </label>
          </div>

          <hr class="form-divider desktop-only">
        </form>

        <div class="show-qr-section desktop-only">
          <button type="button" class="show-qr-btn" (click)="onShowQr()" [disabled]="!menuToEdit">
            <mat-icon class="qr-icon">qr_code</mat-icon>
            <span>{{ 'individual_card.show_qr' | translate }}</span>
          </button>
        </div>
      </div>

      <div class="menu-mobile-basic-footer mobile-only">
        <button type="button" class="menu-mobile-next-btn" (click)="goToMobileItemsStep()">
          <span>{{ 'menu_management.next' | translate }}</span>
          <mat-icon>chevron_right</mat-icon>
        </button>
        <button type="button" class="menu-mobile-cancel-outline-btn" (click)="cancel()" [disabled]="isSubmitting">
          {{ 'Cancel' | translate }}
        </button>
      </div>
    </div>

    <div class="right-column menu-items-panel">
      <div class="menu-mobile-items-body">
      <div class="menu-items-container">
        @if (hasSearchField) {
          <div class="search-field-row">
            <div class="search-field-left">
              <mat-icon class="search-icon">search</mat-icon>
            </div>
            <div class="search-field-input-wrapper">
              <input type="text"
                     [(ngModel)]="searchQuery"
                     (ngModelChange)="onSearchQueryChange()"
                     [placeholder]="'menu_management.search_by_product_name' | translate"
                     class="menu-item-input"
                     [ngModelOptions]="{standalone: true}">
              @if (searchQuery && searchQuery.trim() !== '') {
                <div class="delete-image-button search-clear-button" (click)="clearSearch()">
                  <button type="button" class="delete-icon-button">
                    <img src="../../../../assets/svg/close-icon.svg" alt="">
                  </button>
                </div>
              }
            </div>
            <div class="search-field-right">
              <div class="delete-image-button" (click)="removeSearchField()">
                <button type="button" class="delete-icon-button">
                  <img src="../../../../assets/svg/close-icon.svg" alt="">
                </button>
              </div>
            </div>
          </div>
        }
        <div cdkDropList (cdkDropListDropped)="drop($event)" class="menu-items-list">
          @for (item of getPaginatedItems(); track item.id) {
            <div class="menu-item-row" cdkDrag cdkDragPreviewClass="menu-item-row--drag-preview">
              <button
                type="button"
                class="menu-item-delete-top mobile-only"
                (click)="removeMenuItem(item.id)"
                [attr.aria-label]="'menu_management.delete_menu' | translate">
                <img src="../../../../assets/svg/close-icon.svg" alt="">
              </button>

              <div class="menu-item-card-content mobile-only">
                <div class="menu-item-top-row">
                  <div class="menu-item-left">
                    @if (item.hasQuantity) {
                      <div class="quantity-controls">
                        <button type="button" class="quantity-btn"
                                [disabled]="!item.name || !item.description"
                                (click)="increaseQuantity(item.id); $event.stopPropagation()">
                          <mat-icon class="quantity-icon-top">add</mat-icon>
                        </button>
                        <button type="button" class="quantity-btn"
                                [disabled]="!item.name || !item.description"
                                (click)="decreaseQuantity(item.id); $event.stopPropagation()">
                          <mat-icon class="quantity-icon-bottom">remove</mat-icon>
                        </button>
                      </div>
                    } @else {
                      @if (allowsMultipleProducts) {
                        <input type="checkbox"
                               class="menu-item-checkbox"
                               [checked]="item.selected"
                               (change)="item.selected = !item.selected">
                      } @else {
                        <div class="menu-item-radio"
                             [class.selected]="isMenuItemSelected(item.id)"
                             [class.disabled]="!item.name || !item.description"
                             (click)="(!item.name || !item.description) ? null : selectMenuItem(item.id)"></div>
                      }
                    }
                    <div class="menu-item-image-wrapper">
                      @if (item.image) {
                        <img [src]="item.image" [alt]="'menu_management.menu_item' | translate" class="menu-item-image">
                        <div class="delete-image-button" (click)="removeMenuItemImage(item.id)">
                          <button type="button" class="delete-icon-button">
                            <img src="../../../../assets/svg/close-icon.svg" alt="">
                          </button>
                        </div>
                      } @else {
                        <div class="menu-item-image-placeholder" [class.image-error]="item.imageError">
                          <input type="file" accept=".jpg,.jpeg,.png,.heic" (change)="onImageSelect($event, item.id)" class="image-input" id="image-{{item.id}}">
                          <label for="image-{{item.id}}" class="image-upload-label">
                            <img src="../../../../assets/menu/add_photo_alternate.svg" alt="">
                          </label>
                        </div>
                        @if (item.imageError) {
                          <span class="image-error-message">{{ item.imageError }}</span>
                        }
                      }
                    </div>
                  </div>
                  <input type="text"
                         [(ngModel)]="item.name"
                         [placeholder]="'user_card.name' | translate"
                         class="menu-item-input menu-item-name"
                         [ngModelOptions]="{standalone: true}">
                </div>

                <div class="menu-item-price-row">
                  @if (item.hasQuantity) {
                    <div class="quantity-display">
                      <span class="currency">֏</span>
                      <input type="text"
                             [(ngModel)]="item.quantity"
                             class="quantity-input"
                             [ngModelOptions]="{standalone: true}">
                    </div>
                  } @else {
                    <div class="price-display">
                      <span class="price-icon">֏</span>
                      <input type="text"
                             [value]="item.price ?? ''"
                             (input)="onPriceInput($event, item)"
                             class="price-input">
                    </div>
                  }
                  <div class="menu-item-drag-handle" cdkDragHandle>
                    <mat-icon>drag_indicator</mat-icon>
                  </div>
                </div>

                <input type="text"
                       [(ngModel)]="item.description"
                       [placeholder]="'menu_management.description' | translate"
                       class="menu-item-input menu-item-description"
                       [ngModelOptions]="{standalone: true}">
              </div>

              <div class="menu-item-desktop-layout desktop-only">
                <div class="menu-item-left">
                  @if (item.hasQuantity) {
                    <div class="quantity-controls">
                      <button type="button" class="quantity-btn"
                              [disabled]="!item.name || !item.description"
                              (click)="increaseQuantity(item.id); $event.stopPropagation()">
                        <mat-icon class="quantity-icon-top">add</mat-icon>
                      </button>
                      <button type="button" class="quantity-btn"
                              [disabled]="!item.name || !item.description"
                              (click)="decreaseQuantity(item.id); $event.stopPropagation()">
                        <mat-icon class="quantity-icon-bottom">remove</mat-icon>
                      </button>
                    </div>
                  } @else {
                    @if (allowsMultipleProducts) {
                      <input type="checkbox"
                             class="menu-item-checkbox"
                             [checked]="item.selected"
                             (change)="item.selected = !item.selected">
                    } @else {
                      <div class="menu-item-radio"
                           [class.selected]="isMenuItemSelected(item.id)"
                           [class.disabled]="!item.name || !item.description"
                           (click)="(!item.name || !item.description) ? null : selectMenuItem(item.id)"></div>
                    }
                  }
                  <div class="menu-item-image-wrapper">
                    @if (item.image) {
                      <img [src]="item.image" [alt]="'menu_management.menu_item' | translate" class="menu-item-image">
                      <div class="delete-image-button" (click)="removeMenuItemImage(item.id)">
                        <button type="button" class="delete-icon-button">
                          <img src="../../../../assets/svg/close-icon.svg" alt="">
                        </button>
                      </div>
                    } @else {
                      <div class="menu-item-image-placeholder" [class.image-error]="item.imageError">
                        <input type="file" accept=".jpg,.jpeg,.png,.heic" (change)="onImageSelect($event, item.id)" class="image-input" id="image-desktop-{{item.id}}">
                        <label for="image-desktop-{{item.id}}" class="image-upload-label">
                          <img src="../../../../assets/menu/add_photo_alternate.svg" alt="">
                        </label>
                      </div>
                      @if (item.imageError) {
                        <span class="image-error-message">{{ item.imageError }}</span>
                      }
                    }
                  </div>
                </div>

                <div class="menu-item-middle">
                  <div class="menu-item-input-row">
                    <input type="text"
                           [(ngModel)]="item.name"
                           [placeholder]="'user_card.name' | translate"
                           class="menu-item-input menu-item-name"
                           [ngModelOptions]="{standalone: true}">
                    @if (item.hasQuantity) {
                      <div class="quantity-display">
                        <span class="currency">֏</span>
                        <input type="text"
                               [(ngModel)]="item.quantity"
                               class="quantity-input"
                               [ngModelOptions]="{standalone: true}">
                      </div>
                    } @else {
                      <div class="price-display">
                        <span class="price-icon">֏</span>
                        <input type="text"
                               [value]="item.price ?? ''"
                               (input)="onPriceInput($event, item)"
                               class="price-input">
                      </div>
                    }
                  </div>
                  <input type="text"
                         [(ngModel)]="item.description"
                         [placeholder]="'menu_management.description' | translate"
                         class="menu-item-input menu-item-description"
                         [ngModelOptions]="{standalone: true}">
                </div>

                <div class="menu-item-right">
                  <div class="menu-item-drag-handle" cdkDragHandle>
                    <mat-icon>drag_indicator</mat-icon>
                  </div>
                  <div class="delete-image-button" (click)="removeMenuItem(item.id)">
                    <button type="button" class="delete-icon-button">
                      <img src="../../../../assets/svg/close-icon.svg" alt="">
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        @if (getTotalPages() > 1) {
          <div class="pagination">
            <a (click)="goToItemsPage(currentItemsPage - 1)" [class.disabled]="currentItemsPage === 0">&laquo;</a>
            @for (page of getPageNumbers(); track page) {
              <a (click)="goToItemsPage(page - 1)"
                 [class.active]="currentItemsPage === (page - 1)">
                {{ page }}
              </a>
            }
            <a (click)="goToItemsPage(currentItemsPage + 1)" [class.disabled]="currentItemsPage >= getTotalPages() - 1">&raquo;</a>
          </div>
        }
      </div>

      <div class="menu-mobile-items-actions mobile-only">
        <button type="button" class="menu-mobile-save-btn" [disabled]="isSubmitting || menuForm.invalid || !canSave" (click)="onSubmit()">
          {{ 'user_card.save' | translate }}
        </button>
        <button type="button" class="menu-mobile-cancel-outline-btn" (click)="cancel()" [disabled]="isSubmitting">
          {{ 'Cancel' | translate }}
        </button>
        <button type="button" class="menu-mobile-show-qr-link" (click)="onShowQr()" [disabled]="!menuToEdit">
          <mat-icon>qr_code</mat-icon>
          <span>{{ 'individual_card.show_qr' | translate }}</span>
        </button>
      </div>
      </div>

      <div class="form-footer-actions desktop-only">
        <button type="button" class="footer-cancel-btn" (click)="cancel()" [disabled]="isSubmitting">
          {{ 'Cancel' | translate }}
        </button>
        <button type="submit" class="footer-save-btn" [disabled]="isSubmitting || menuForm.invalid || !canSave" (click)="onSubmit()">
          {{ 'user_card.save' | translate }}
        </button>
      </div>
    </div>
  </div>

  @if (mobileStep === 'items') {
  <div class="menu-mobile-bottom-sheet mobile-only">
    <div class="menu-mobile-sheet-handle" aria-hidden="true"></div>
    <div class="checkbox-section menu-mobile-sheet-checkbox">
      <label class="checkbox-label">
        <input
          type="checkbox"
          class="checkbox-input"
          [checked]="allowsMultipleProducts"
          [disabled]="!isMultiSelectAllowed"
          (change)="setAllowsMultipleProducts($any($event.target).checked)">
        <span>{{ 'menu_management.allow_multiple_selection' | translate }}</span>
      </label>
    </div>
    @if (hasSearchField) {
      <div class="menu-mobile-sheet-search">
        <mat-icon>search</mat-icon>
        <span>{{ 'menu_management.add_search' | translate }}</span>
      </div>
    } @else {
      <button type="button" class="action-button add-search-btn" (click)="onAddSearch()">
        <mat-icon>search</mat-icon>
        <span>{{ 'menu_management.add_search' | translate }}</span>
      </button>
    }
    <button type="button" class="action-button add-quantity-btn" (click)="onAddMenuItemWithQuantity()">
      <div class="quantity-icon-wrapper">
        <img src="../../../../assets/menu/menu_qty_icon.svg" style="width: 13px;" alt="">
      </div>
      <span>{{ 'menu_management.add_menu_item_with_quantity' | translate }}</span>
    </button>
    <button type="button" class="action-button add-standard-btn" (click)="onAddStandardMenuItem()">
      <mat-icon>add</mat-icon>
      <span>{{ 'menu_management.add_standard_menu_item' | translate }}</span>
    </button>
  </div>
  }
</div>
